module.exports = __webpack_public_path__ + "media/images/icon-precautions@3x-7cb34f6684de823e56020854dbd212ff.png";